export default __webpack_public_path__ + "static/media/image20.1f2ebb32.png";